<template>
    <div class="main-blog" v-if="blogPosts.length">
        <div class="slider-top d-flex align-items-center justify-content-between">
            <div class="title">Блог здоров’я</div>
            <div class="d-flex align-items-center">
                <inertia-link :href="route('frontend.blog.index')" class="button-all d-flex align-items-center">
                    <span class="value">Переглянути всі</span>
                    <span class="ic icon-Severicons2"></span>
                </inertia-link>
                <div class="navs catalog-slider__navs d-flex"></div>
            </div>
        </div>

        <div class="blog-items d-xl-flex align-items-start">
            <div class="blog-item-big" v-if="firstPost">
                <inertia-link :href="firstPost.url" class="item-big-image">
                    <img :src="firstPost.image_url" :alt="firstPost.alt" class="lozad" loading="lazy">
                </inertia-link>
                <div class="item-big-info">
                    <div class="info-top">
                        <div class="meta">
                            <span class="date">{{ firstPost.published_at }}</span>
                            <inertia-link :href="firstPost.url + '#comments'"
                                          class="revs d-flex align-items-center">
                                <span class="ic icon-revs"></span>
                                <span class="value">{{ firstPost.comments_count }}</span>
                            </inertia-link>
                        </div>

                        <div class="tags">
                            <inertia-link v-for="cat in firstPost.categories" :href="cat.url"
                                          :key="'cat-'+cat.id"
                                          class="tag">{{ cat.title }}
                            </inertia-link>
                        </div>

                    </div>
                    <inertia-link :href="firstPost.url" class="name">{{ firstPost.title }}</inertia-link>
                    <div class="author d-flex align-items-center">
                        <div class="author-photo"><img src="/images/avatar.png" alt="" class="lozad" loading="lazy"></div>
                        <div class="author-info">
                            <div class="author-anons" v-if="false">Лікар педіатр</div>
                            <div class="author-name">{{ firstPost.author_name || firstPost.author.name }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="blog-items-small" v-if="secondPost">
                <div class="blog-item-small d-sm-flex align-items-center">
                    <inertia-link :href="secondPost.url" class="item-small-image">
                        <img :src="secondPost.image_url" :alt="secondPost.alt" class="lozad" loading="lazy">
                    </inertia-link>
                    <div class="item-small-info">
                        <div class="info-top">
                            <div class="meta">
                                <span class="date">{{ secondPost.published_at }}</span>
                                <inertia-link :href="secondPost.url + '#comments'"
                                              class="revs d-flex align-items-center">
                                    <span class="ic icon-revs"></span>
                                    <span class="value">{{ secondPost.comments_count }}</span>
                                </inertia-link>
                            </div>

                            <div class="tags">
                                <inertia-link v-for="cat in secondPost.categories" :href="cat.url"
                                              :key="'cat-'+cat.id"
                                              class="tag">{{ cat.title }}
                                </inertia-link>
                            </div>


                        </div>
                        <inertia-link :href="secondPost.url" class="name">{{ secondPost.title }}</inertia-link>
                        <div class="author d-flex align-items-center">
                            <div class="author-photo"><img src="/images/avatar.png" alt="" class="lozad" loading="lazy"></div>
                            <div class="author-info">
                                <div class="author-name">{{ secondPost.author_name || secondPost.author.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blog-items-small" v-if="thirdPost">
                    <div class="blog-item-small d-sm-flex align-items-center">
                        <inertia-link :href="thirdPost.url" class="item-small-image">
                            <img :src="thirdPost.image_url" :alt="thirdPost.alt" class="lozad" loading="lazy">
                        </inertia-link>
                        <div class="item-small-info">
                            <div class="info-top">
                                <div class="meta">
                                    <span class="date">{{ thirdPost.published_at }}</span>
                                    <inertia-link :href="thirdPost.url + '#comments'"
                                                  class="revs d-flex align-items-center">
                                        <span class="ic icon-revs"></span>
                                        <span class="value">{{ thirdPost.comments_count }}</span>
                                    </inertia-link>
                                </div>
                                <div class="tags">

                                    <inertia-link v-if="thirdPost.category" :href="thirdPost.category.url"
                                                  class="tag">{{ thirdPost.category.title }}
                                    </inertia-link>
                                </div>


                            </div>
                            <inertia-link :href="thirdPost.url" class="name">{{ thirdPost.title }}</inertia-link>
                            <div class="author d-flex align-items-center">
                                <div class="author-photo"><img src="/images/avatar.png" alt="" class="lozad" loading="lazy"></div>
                                <div class="author-info">
                                    <div class="author-name">{{ thirdPost.author_name || thirdPost.author.name }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
    blogPosts: [Object, Array]
})

const firstPost = computed(() => props.blogPosts[0] || null)
const secondPost = computed(() => props.blogPosts[1] || null)
const thirdPost = computed(() => props.blogPosts[2] || null)
</script>
